import { navLinks } from "@/mocks/comicData";

function Footer() {
  const handleNav = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-primary-700 text-primary-50">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                handleNav("home");
              }}
              className="flex items-center gap-2"
              aria-label="大黄丫头漫画首页"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-emotion-laugh-line"></i>
              </span>
              <span className="font-heading text-xl text-background-50">
                大黄丫头<span className="text-secondary-300">漫画</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/80">
              大黄丫头漫画官网收录大黄丫头漫画搞笑日常与幽默片段，轻松向剧情一话不落。想找大黄丫头漫画笑点合集、看轻松解压内容，直接从这里进，笑出鹅叫不是梦。
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-douban-line", label: "豆瓣" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#home"
                  onClick={(e) => e.preventDefault()}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-lg text-primary-50 transition-colors hover:bg-secondary-500 hover:text-primary-900"
                  aria-label={s.label}
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">栏目导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNav(link.id);
                    }}
                    className="text-sm text-primary-100/80 transition-colors hover:text-secondary-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-secondary-300"></i>
                hello@dahuangyatou.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-secondary-300"></i>
                每周二 · 四 · 六更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-secondary-300"></i>
                大黄丫头漫画官网
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-600/60 pt-6 text-xs text-primary-100/70 sm:flex-row">
          <p>© {new Date().getFullYear()} 大黄丫头漫画官网 · 所有内容仅供个人娱乐</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-emotion-laugh-line"></i>
            愿每个平凡日子都笑口常开
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;